import { bindings } from '@polleverywhere/slideware-bindings'
import { singularize } from '@polleverywhere/core/lib/util.js'

export default async (app) => {
  const dispatcher = _.clone(Backbone.Events)

  dispatcher.listenTo(app, 'reset:state', (state) => { // top-level app state has been reset
    dispatcher.listenTo(state.appStates.activities, 'change:pageAction', async (activityAppState, newPageAction, options = {}) => {
      const previousPageAction = activityAppState.previous('pageAction')
      if (previousPageAction === 'edit' && newPageAction === null) {
        if (options.cancel) {
          return
        }

        const activityUrls = await bindings.allActivityUrls().catch(() => { return null })
        const activityModel = activityAppState.get('activity')
        const isActivityInSlideware = activityUrls && activityUrls.find(url => {
          const type = singularize(url.segment(0))
          const permalink = url.segment(1)
          return (activityModel.get('type') === type && activityModel.get('permalink') === permalink)
        })

        if (!isActivityInSlideware) return

        state.appStates.slideware.set({
          page: 'sync',
          activity: activityAppState.get('activity')
        })
      }
    })
  })
}
